import { useDispatch, useSelector } from 'react-redux';
import { Sound } from '../shared/ui/Sound/Sound';
import './styles/index.scss';
import { RootState } from '../shared/redux/store';
import { Pages } from '../shared/redux/page/types';
import { Onboarding } from '../pages/Onboarding/Onboarding';
import { Game } from '../pages/Game/Game';
import { Final } from '../pages/Final/Final';
import { Prefinal } from '../pages/Prefinal/Prefinal';
import { useEffect, useState } from 'react';
import { toggleSound } from '../shared/redux/page/slice';

function App() {
  const dispatch = useDispatch();
  const page = useSelector((state: RootState) => state.page.currentPage);
  const [firstClick, setFirstClick] = useState(false);
  const currentScreen = () => {
    switch (page) {
      case Pages.ONBOARDING:
        return <Onboarding />;
      case Pages.GAME:
        return <Game />;
      case Pages.PREFINAL:
        return <Prefinal />;
      case Pages.FINAL:
        return <Final />;
    }

    return <Onboarding />;
  };
  useEffect(() => {
    if (firstClick) {
      dispatch(toggleSound());
    }
  }, [firstClick]);
  return (
    <div
      className="App"
      onClick={() => {
        if (!firstClick) {
          setFirstClick(true);
        }
      }}>
      <div className="blur"></div>
      <div className="mobile-window" id="app-window">
        {currentScreen()}
        <Sound />
      </div>
    </div>
  );
}

export default App;
